import { render, staticRenderFns } from "./pageHeader.vue?vue&type=template&id=3f93b81c&scoped=true"
var script = {}
import style0 from "./pageHeader.vue?vue&type=style&index=0&id=3f93b81c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f93b81c",
  null
  
)

export default component.exports